export const getFirstElement = (errors, offsetY = 0, firstElement, prefix = '') => {
  Object.keys(errors).forEach((element) => {
    if (errors[element].error_type) {
      const el = document.getElementById(`${prefix}${element}`)
      if (el) {
        const top = el.getBoundingClientRect().y
        if (top < offsetY) {
          offsetY = top
          firstElement = `${prefix}${element}`
        }
      } else {
        const ele = document.getElementById(`${prefix}${errors[element].error_type}`)
        if (ele) {
          const top = ele.getBoundingClientRect().y
          if (top < offsetY) {
            offsetY = top
            firstElement = `${prefix}${errors[element].error_type}`
          }
        }
      }
    } else {
      firstElement = getFirstElement(errors[element], offsetY, firstElement, `${prefix}${element}-`)
    }
  })
  return firstElement
}
